import React, { useState } from "react";
import { WrappedFieldInputProps, WrappedFieldMetaProps } from "redux-form";
import Selection from "../Selection";

interface RadioProps {
  label: string;
  value: string;
  helperTextEnabled?: boolean;
  helperText?: string;
}

interface Props {
  name: string;
  title?: string;
  handleRadioClick: (value: string) => void;
  items: Array<RadioProps>;
  input: Partial<WrappedFieldInputProps>;
  change: (field: string, value: string) => void;
  meta: Partial<WrappedFieldMetaProps>;
  initialValue?: string;
  disabled?: boolean;
}

const RadioGroup: React.FC<Props> = ({ title, handleRadioClick, items, input, change, meta, initialValue, disabled = false }: Props) => {
  const [radioInitialValue, setRadioInitialValue] = useState(initialValue ? initialValue : null);

  const handleUpdate = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target;

    if (radioInitialValue) {
      setRadioInitialValue(value);
    }

    change(input.name, value);
    handleRadioClick(value);
  };

  if (radioInitialValue) {
    input.value = radioInitialValue;
  }

  return (
    <div className="caprx-radio-group-container">
      {title ? <span className="caprx-radio-group-title">{title}</span> : null}
      {items.map(({ label, value, helperText = "", helperTextEnabled = false }: RadioProps) => {
        return (
          <Selection
            key={value}
            id={value}
            type="radio"
            checked={value === input.value}
            label={label}
            value={value}
            onChange={handleUpdate}
            helperTextEnabled={helperTextEnabled}
            helperText={helperText}
            meta={meta}
            input={input}
            disabled={disabled}
          />
        );
      })}
    </div>
  );
};

export default RadioGroup;
